import { ThemeProvider } from '@emotion/react'
import { Box, Button, Container, IconButton } from '@mui/material'
import MUIDataTable from 'mui-datatables'
import * as React from 'react'
import theme from '../theme'
import api from '../services/api'
import AddIcon from '@mui/icons-material/Add';
import FormDialog from './FormDialog'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { module } from './FormDialog'
import { useAuth } from '../auth/AuthProvider'
import { useNavigate } from 'react-router-dom'
import moment from "moment";
import 'moment/locale/pt-br'

export default function(){
    const navigate = useNavigate()
    const [ handlerDialog, setHandlerDialog ] = React.useState(false)
    const [update, setUpdate] = React.useState(false)
    const [id, setId] = React.useState(false)
    const  auth = useAuth()
    React.useEffect(()=>{
        setUpdate(false)
        updateData()

    },[handlerDialog,update])
    const [data, setData] = React.useState()
    React.useEffect(()=>{
        document.title = "Horus - Tokens"
      },[])

    const columns =[
        {
            name:'id',
            label:'Id',
            options:{
                display: false
            }
            
        },
        {
            name:'description',
            label: "Descrição",
            options: {
                filter: true,
                sort: true,}
        },
        {
            name:'last_utilization',
            label: "Ultima Utilização",
            options: {
                filter: true,
                sort: true,
                 customBodyRender: value => {
                    return value ? moment(value).format('DD/MM/YYYY HH:mm:ss') : 'Nunca Utilizado'
            }
        }
        },
        {
            name: "actions",
            label: "Ações",
            options:{
              customBodyRenderLite : (dataIndex, rowIndex)=>
              <>
                <Button disabled={!auth.hasPerm('token.delete')} sx={{ color:theme.palette.text.primary}} onClick={()=>{
                    const id = data[dataIndex].id
                    const name = data[dataIndex].description 
                    deleteItem(id, name)
                    
                }}>
                <DeleteIcon/>
            </Button>
            </>
            
            }
          }
    ]
    const deleteItem =(id, name)=>{
        const conf = confirm(`Deseja realmente apagar o cargo: ${name}`)
        if(!conf) return
        api.delete(`${module}/delete/${id}/`).then(()=>{
           setUpdate(true)
        }).catch(err => console.log(err))
    }
    const updateData = ()=>{
        api.get(`${module}/all`)
        .then(res => setData(res.data)).catch((err) => {
            if(err.response.status==401){
              navigate('/401')
            }
            setData()
          })
    }
    const showFormDialog = ()=>{
        setId()
        setHandlerDialog(true)
    }
    const options = {
        filterType: 'checkbox',
        rowsPerPageOptions : [30, 50, 100, 500],
        rowsPerPage: 30,
        rowHover: false,
        print: false,
        selectableRows: 'none' ,
        download: false,
        customToolbar : ()=> <IconButton onClick={showFormDialog} disabled={!auth.hasPerm('token.create')} sx={{color: theme.palette.text.primary }}><AddIcon/></IconButton>, 
        customToolbarSelect: () => {},
    }
    return(
        <Container  maxWidth='lg' sx={{ mt: 4, mb: 4 }}>
            <ThemeProvider theme={theme}>
            <FormDialog open={handlerDialog} id={id} handlerClose={()=>{setHandlerDialog(false)
            setId(false)
            }} updateData={updateData}/>
            <Box sm={12} lg={10}>
            <MUIDataTable
            title={"Tokens"}
            data={data}
            columns={columns}
            options={options}
            />
            </Box>
        </ThemeProvider>
          </Container>
    )
}